module.exports = __webpack_public_path__ + "static/media/home-page.3e0fe425.gif";